<style scoped>
td:last-child,
th:last-child {
  width: 20%;
}
</style>

<template lang="pug">
    .row
      .col.s12
        ul.stepper.linear
          li.step.active
            .step-title.waves-effect Upload Inventory Spreadsheet
            .step-content
              .row
                .file-field.input-field
                  .btn
                    span Choose File
                    input#inventory-spreadsheet(type='file', @change='upload', accept='.xlsx')
                  .file-path-wrapper
                    input#inventory-spreadsheet-path.file-path.validate(
                      type="text",
                      :class="sheetValid === false ? 'invalid' : ''")
                span.red-text(v-if='sheetValid === false') Selected file contains an invalid format
          li.step
            .step-title.waves-effectPasso Review Inventory
            .step-content
              .row
                .col.s12
                  table.compact
                    thead
                      th Product
                      th.right-align Available Stocks
                    tbody
                      tr(v-for='inventory in inventories')
                        td {{inventory.variantCode}}
                        td.right-align
                          input.right-align(v-model='inventory.availableStock')
              .row.step-actions
                .col.s12
                  button.waves-effect.waves-dark.btn.next-step(@click='post') Upload

        .row(v-if='uploading')
          .progress
            .determinate(:style='{width: uploadPercent + "%"}')
          p.subtitle.small.center-align {{uploadMessage}} ({{uploadPercent + "%"}})
</template>
<script>
import xlsx from 'xlsx'
import $ from 'jquery'
import Promise from 'bluebird'
require('materialize-stepper')
require('materialize-stepper/materialize-stepper.min.css')

export default {
  meta: {
    title: 'Upload Inventory'
  },
  props: ['inventory'],
  data () {
    return {
      workbook: null,
      inventories: null,
      uploadMessage: null,
      uploadPercent: 0,
      uploading: false
    }
  },
  mounted () {
    $('.stepper').activateStepper({
      linearStepsNavigation: false,
      autoFocusInput: false,
      autoCreateForm: false
    })
  },
  computed: {
    sheetValid () {
      return true
    },
    supplier () {
      return this.$store.state.profile.supplier
    }
  },
  methods: {
    upload (e) {
      const fileReader = new FileReader()
      fileReader.onload = this.onFileLoaded
      fileReader.readAsArrayBuffer(e.target.files[0])
    },
    async onFileLoaded (e) {
      const data = new Uint8Array(e.target.result)
      this.workbook = xlsx.read(data, { type: 'array', cellFormula: false })
      this.inventories = await this.buildInventories()
      if (this.inventories) {
        $('.stepper').nextStep()
      }
    },
    buildInventories () {
      if (!this.workbook) {
        return
      }
      const firstSheet = this.workbook.Sheets[this.workbook.SheetNames[0]]
      let rows = xlsx.utils.sheet_to_json(firstSheet)

      let inventories = []
      const valid = rows.every((row, index) => {
        inventories.push({
          variantCode: row['variant code'],
          availableStock: row['available stock']
        })
        return row['available stock'] && row['variant code']
      })

      if (valid) {
        return inventories
      } else {
        this.$snackbar.error('Oops, an error occurred while uploading the inventory')
      }
    },
    post () {
      this.uploading = true
      this.uploadMessage = 'Uploading inventory'
      this.uploadPercent = 0

      const batchSize = 20
      const batchCount = Math.ceil(this.inventories.length / batchSize)

      const batches = []
      for (let i = 0, len = batchCount; i < len; i++) {
        batches.push(this.uploadInventories(this.inventories.slice(i * batchSize, (i + 1) * batchSize)))
      }

      return Promise
        .each(batches, (res, index, len) => {
          this.uploadPercent = Math.ceil((index + 1) / len * 100)
        }).then(() => {
          this.$snackbar.success('Inventory uploaded successfully')
          this.uploading = false
        }).catch(() => {
          this.$snackbar.error('Oops, an error occurred while uploading the inventory')
        })
    },
    uploadInventories (inventories) {
      return this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        return this.$http
          .post(
            `${this.$config.API_URL}/suppliers/${this.supplier.id}/inventories/${this.inventory.id}`,
            {
              products: inventories
            },
            {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }
          )
      })
    },
    reset () {
      this.workbook = null
      this.inventories = null
      $('#inventory-spreadsheet').val(null)
      $('.file-path').val(null)
      $('.stepper').resetStepper(1)
      $('.done').removeClass('done')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-inventory-upload.vue